const captions = {
  addressField: {
    enterManually: 'Enter manually',
    noAddressSelected: 'No address selected'
  },
  autoRefresh: {
    autoRefresh: 'Auto refresh',
    never: 'Never',
    oneMinute: '1 Minute',
    fiveMinutes: '5 Minutes',
    tenMinutes: '10 Minutes',
    fifteenMinutes: '15 Minutes',
    thirtyMinutes: '30 Minutes',
    fortyFiveMinutes: '45 Minutes',
    oneHour: '1 Hour',
    twoHours: '2 Hours',
    threeHours: '3 Hours',
    fourHours: '4 Hours'
  },
  changePassword: {
    cancel: 'Cancel',
    changePassword: 'Change Password',
    confirmPassword: 'Confirm Password',
    newPassword: 'New Password',
    oldPassword: 'Old Password',
    passwordsAreNotIdentical: 'Passwords are not identical',
    passwordChangedSuccess: 'Password changed successfully! Use your new password the next time you log in.',
    passwordRequired: 'Password is required'
  },
  conversation: {
    follow: 'Follow',
    followers: 'Followers',
    placeholder: 'Write your message here...',
    send: 'Send',
    following: 'Following',
    addFollowers: 'Add followers',
    searchPotentialFollowers: 'Search for {0}',
    dialog: {
      cancel: 'Cancel',
      close: 'Close',
      removeFollower: {
        areYourSure: 'Are you sure you want to remove follower {0}?',
        no: 'No',
        title: 'Remove follower',
        yes: 'Yes'
      },
      unsentMessage: {
        cancel: 'Cancel',
        discard: 'Discard',
        haveUnsentMessage: 'You have an unsent message.',
        send: 'Send',
        title: 'Unsent message'
      },
      addFollowersFailure: {
        title: 'Error adding followers',
        message: 'An error occurred while adding followers. We were unable to add the {0} followers.'
      }
    }
  },
  colorScheme: {
    addRule: 'Add Rule',
    colorSchemeName: 'Color Scheme Name',
    colorSchemeTitle: 'Color Scheme',
    colorSchemesTitle: 'Color Schemes',
    createNewColorScheme: 'Create New Scheme',
    manageColorSchemes: 'Manage Color Schemes',
    userDefinedColorSchemes: 'User Defined',
    systemDefinedColorSchemes: 'System Defined',
    standardColorScheme: 'Standard',
    delete: 'Delete',
    edit: 'Edit',
    ok: 'OK',
    loadSaved: 'Load Saved',
    header: 'Header',
    ruleBackgroundColor: 'Background Color',
    ruleTextColor: 'Text Color',
    ruleFilter: 'Filter',
    ruleName: 'Name',
    cancel: 'Cancel',
    noAvailableColorSchemes: 'There are no available color schemes',
    published: 'Published',
    schemeDetails: 'Scheme Details',
    rules: 'Rules',
    confirmDeleteTitle: 'Delete Color Scheme',
    confirmDeleteCaption: 'This color scheme will be removed from the system. Are you sure you want to delete {0}?'
  },
  dateField: {
    ariaLabelPrompter: 'Selecteer Datum',
    today: 'Vandaag'
  },
  dateOffset: {
    atLeast: 'At least',
    atMost: 'At most'
  },
  dateTimeField: {
    ariaLabelPrompter: 'Selecteer Datum',
    now: 'Nu',
    setDate: 'Kies Datum',
    setTime: 'Kies Tijd',
    today: 'Vandaag'
  },
  dialog: {
    acknowledge: 'Click to acknowledge that you have read and understood this warning.',
    apply: 'Apply',
    cancel: 'Cancel',
    clear: 'Clear',
    ok: 'OK',
    publish: 'Publish for all users',
    reset: 'Reset',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    applyChanges: 'Apply changes'
  },
  documentViewer: {
    info: 'Document information',
    print: 'Print document',
    download: 'Download document',
    thumbnails: 'Show thumbnails',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotate: 'Rotate',
    details: 'Document details: ',
    name: 'Document name: ',
    type: 'Document type: '
  },
  drawer: {
    copyLink: 'Copy link',
    entityActions: 'Entity actions',
    openInNewTab: 'Open in new tab',
    toggleFavorite: 'Toggle favorite'
  },
  userImpersonation: {
    email: 'Email Address',
    impersonate: 'Impersonate',
    impersonatingWarning: 'You are now impersonating this user, any action you take will be logged as this user and NOT you!',
    impersonateUser: 'Impersonate User',
    organization: 'Organization Code',
    error: 'Impersonate Error'
  },
  search: {
    multipleChip: 'Multiple',
    noResults: 'No matches found',
    placeholder: 'Search',
    results: 'Top Results',
    suggestedFilters: 'Suggested Filters',
    searchableFields: 'Searchable Fields',
    restrictSearch: 'Restrict the search to',
    matchedOn: 'Matched on',
    open: 'Open',
    close: 'Close',
    jump: 'Jump To',
    add: 'Add'
  },
  searchDataTable: {
    addSort: 'Add sort',
    edit: 'Wijzig',
    new: 'Nieuw',
    addGroup: 'Add group',
    clearAll: 'Clear all',
    collapseAllGroups: 'Collapse all groups',
    deleteRow: 'Delete Row',
    dragMoved: 'Moved 1 item',
    dragMovedMultiple: 'Moved {0} items',
    dragMoving: 'Moving 1 item',
    dragMovingMultiple: 'Moving {0} items',
    groupBy: 'Group by',
    expandAllGroups: 'Expand all groups',
    nonEditableField: 'Non-editable field',
    noItemsFound: 'Geen resultaat',
    search: 'Zoek',
    selectColumn: 'Select column',
    selected: '{0} geselecteerd',
    selectMore: 'Select at least two rows to see available bulk actions.'
  },
  searchList: {
    availableHeaders: 'Available columns',
    alertToggleCallout: 'Data table rows are being filtered by alerts.',
    configureHeaders: 'Configure columns',
    cancel: 'Cancel',
    closeGroup: 'Close Group',
    count: 'Count: {0}',
    delete: 'Verwijder',
    empty: '(empty)',
    enableHeaderSizing: 'Enable column sizing',
    export: 'Export',
    firstUse: {
      header: 'No records to show',
      bodycopy: 'Add a row to start populating the table'
    },
    headers: 'Columns',
    searchColumns: 'Search columns',
    clearColumns: 'Clear all',
    colors: 'Colors',
    hideAggregateAria: 'Hide aggregations',
    item: '1 resultaat',
    itemActions: 'Item Actions',
    items: '{0} resultaten',
    groupBy: 'Group by column',
    lock: 'Lock',
    new: 'Nieuw',
    noData: {
      header: 'No results found',
      bodycopy: 'Try adjusting your filters to find more results',
      buttonLabel: 'Search'
    },
    noItemsFound: 'Geen resultaat',
    openGroup: 'Open Group',
    refresh: 'Refresh',
    save: 'Save',
    search: 'Zoek',
    selectedHeaders: 'Selected columns',
    settings: 'Settings',
    showAggregateAria: 'Show aggregations',
    sort: 'Sorteer',
    sortTitle: 'Sort by',
    stopGrouping: 'Stop Grouping',
    toggleFilterAria: 'Filter by column',
    toggleSort: 'Sort by column',
    unlock: 'Unlock',
    wrap: 'Wrap'
  },
  filters: {
    add: 'Add',
    addGroup: 'Add Group',
    and: 'And',
    all: 'All',
    categoryBoolean: 'Flags',
    categoryCollection: 'Related Records',
    categoryDate: 'Dates',
    categoryGeo: 'Geo Locations',
    categoryNumber: 'Numbers',
    categoryOther: 'Other',
    categoryText: 'Text Search',
    contains: 'contains',
    endsWith: 'ends with',
    fieldSelectAriaLabel: 'Field',
    filter: 'Filter',
    filters: 'Filters',
    filtersTitle: 'Filters',
    from: 'From',
    greaterThan: 'greater than',
    greaterThanOrEqual: 'greater than or equal to',
    group: 'Group',
    hasDate: 'has date',
    hasDuration: 'has duration',
    hasNoDate: 'has no date',
    hasNoDuration: 'has no duration',
    header: 'Header',
    invalidField: 'Field does not exist',
    is: 'is',
    isBetween: 'is between',
    isBetweenOrEqual: 'is between or equal to',
    isBlank: 'is blank',
    isInTheDateRange: 'is in the date range',
    isInTheDateRangeValuePrefix: 'from',
    isInTheDateRangeValue2Prefix: 'to',
    isInThePast: 'is in the past',
    isInTheFuture: 'is in the future',
    isNot: 'is not',
    isNotBetween: 'is not between',
    isNotBetweenOrEqual: 'is not between or equal to',
    isNotBlank: 'is not blank',
    isNotSpecified: 'is not specified',
    isSpecified: 'is specified',
    lessThan: 'less than',
    lessThanOrEqual: 'less than or equal to',
    maxValue: 'Maximum value',
    minValue: 'Minimum value',
    more: 'more',
    no: 'No',
    notContain: 'not contain',
    notEnding: 'not ending',
    noFiltersApplied: 'No filters applied',
    notStarting: 'not starting',
    numberOfFiltersApplied: '{0} filters applied',
    oneFilterApplied: '1 filter applied',
    operationSelectAriaLabel: 'Operation',
    or: 'Or',
    selectFilter: '--- Select filter ---',
    startsWith: 'starts with',
    to: 'To',
    isEarlierThan: 'is earlier than',
    isLaterThan: 'is later than',
    value: 'Value',
    yes: 'Yes',
    filterName: 'Filter Name',
    loadSaved: 'Load Saved',
    delete: 'Delete',
    stopIfTrue: 'Stop If True',
    doesNotExist: 'does not exist',
    showAlertsOnly: 'Show Alerts Only',
    exists: 'exists',
    showAll: 'Show All',
    toggleQuickFilter: 'Click to filter by alerts',
    toggleQuickFilterOff: 'Click to remove alert filter',
    valueSelectAriaLabel: 'Value',
    value1SelectAriaLabel: 'First value',
    value2SelectAriaLabel: 'Second value'
  },
  headers: {
    categoryBoolean: 'Flags',
    categoryDate: 'Dates',
    categoryNumber: 'Numeric',
    categoryText: 'Text',
    addresses: 'Addresses',
    measurement: 'Measurement',
    categoryGeo: 'Geo Locations',
    categoryCollection: 'Related Records',
    categoryUnassigned: 'Unassigned'
  },
  imagePicker: {
    acceptButton: 'Ok',
    fileErrorHeader: 'Ongeldig bestand',
    invalidFileError: 'Dit bestandsformaat is niet geldig. Zorg ervoor dat u een PNG, Bitmap of een JPEG afbeelding kiest.',
    maxFileSizeError: 'Dit bestand is te groot en kan voor problemen zorgen. Kies een kleiner bestand.'
  },
  jobAddress: {
    address2FieldLabel: 'Address line 2',
    addressFieldLabel: 'Address line 1',
    searchAddressPlaceholder: 'Search for address',
    additionalInfoLabel: 'Additional information',
    cityFieldLabel: 'City',
    companyNameLabel: 'Organization name',
    contactFieldLabel: 'Fullname',
    contactPlaceholder: 'Search for contact',
    contactTab: 'Contact',
    countryFieldLabel: 'Country',
    edit: 'Edit',
    emailFieldLabel: 'Email',
    errorState: 'There is error in the job address',
    mobileFieldLabel: 'Mobile',
    phoneFieldLabel: 'Phone',
    mapLabel: 'Map location',
    noAddress: 'No address supplied.',
    noContactDetails: 'No contact details supplied.',
    postcodeFieldLabel: 'Postal/Zip Code',
    stateFieldLabel: 'State/Province/Region',
    streetAltFieldLabel: 'Street (alt)',
    streetFieldLabel: 'Street',
    warningState: 'There is warning in the job address'
  },
  lookup: {
    noResults: 'Geen records gevonden',
    notAvailable: 'NOT AVAILABLE',
    showing: '1 tot {0} van {1} resultaten',
    showMore: 'Laad meer'
  },
  menu: {
    more: 'More',
    actions: 'Acties',
    bulkActions: 'Bulk Acties'
  },
  passwordField: {
    capsLockMessage: 'Caps Lock staat aan'
  },
  textField: {
    ariaLabelPrompter: 'Prompt'
  },
  timeField: {
    ariaLabelPrompter: 'Select Time',
    now: 'Nu'
  },
  schedule: {
    actionsHeader: 'Acties',
    activeHeader: 'Actief',
    addBreak: 'Voeg Pauze toe',
    breaksHeader: 'Pauzes',
    breaksOverlap: 'Overlappende pauzes',
    copyDay: 'Kopiëren',
    dayHeader: 'Dag',
    hours: 'Uur',
    invalidEndTime: 'Ongeldige eind tijd',
    invalidStartTime: 'Ongeldige start tijd',
    minutes: 'Minuten',
    pasteDay: 'Plakken',
    removeBreak: 'Verwijder Pauze',
    timeHeader: 'Tijd',
    totalHeader: 'Totaal'
  },
  searchBox: {
    noResults: 'Geen records gevonden',
    showing: '1 tot {0} van {1} resultaten',
    showMore: 'Laad meer'
  },
  searchControl: {
    ariaLabelPrompter: 'Advanced search dialog',
    noResults: 'Geen records gevonden',
    showing: '1 tot {0} van {1} resultaten',
    showMore: 'Laad meer'
  },
  weekDay: {
    monday: 'Maandag',
    tuesday: 'Dinsdag',
    wednesday: 'Woensdag',
    thursday: 'Donderdag',
    friday: 'Vrijdag',
    saturday: 'Zaterdag',
    sunday: 'Zondag'
  },
  fileAttachment: {
    add: 'Toev',
    clearAll: 'Alles wissen',
    clearUnsaved: 'Niet-opgeslagen wissen',
    dropFile: 'Zet uw bestand hier neer of gebruik de knop Met het plusteken',
    dropFiles: 'Zet uw bestanden hier neer of gebruik de knop Toevoegen',
    noFiles: 'Geen bestanden'
  },
  layouts: {
    confirmDelete: 'Are you sure you want to delete {0}?',
    confirmDeletePublic: `Warning: This is a published filter that is available to all users. 
        Are you sure you want to delete {0}?'`,
    confirmDeleteTitle: 'Delete Filter',
    confirmOverride: '{0} already exists. Are you sure you want to replace the existing filter?',
    confirmOverrideTitle: 'Warning - Replace Filter',
    displayTimestamp: 'Display timestamp',
    editLayout: 'Edit Filter',
    includeFilter: 'Include Filter',
    includeHeaders: 'Include Headers',
    includeColorScheme: 'Include Color Scheme',
    includeDense: 'Include Dense',
    dense: 'Dense',
    layoutName: 'Filter Name',
    layouts: 'Filters',
    layoutsMenuAria: 'More actions',
    manageLayouts: 'Manage Filters',
    noAvailableLayouts: 'There are no available filters',
    lastRefreshed: 'Last refreshed',
    resetLayout: 'Reset Current',
    saveLayout: 'Save Current',
    setAutoRefresh: 'Set auto refresh ',
    viewLayouts: 'Manage Filters'
  },
  themeConfiguration: {
    cancel: 'Cancel',
    close: 'Close',
    color: 'Color',
    colors: 'Colors',
    copyThemeFrom: 'Copy Theme From',
    custom: 'Custom',
    dark: 'Dark',
    portal: 'Portal',
    primary: 'Primary',
    brand: 'Brand',
    zebraStripes: 'DataTable Zebra Stripes',
    lightTheme: 'Light theme',
    darkTheme: 'Dark theme',
    logo: 'Logo',
    logoColor: 'Logo Background',
    logoDarkDescription: 'Dark Logo',
    logoLightDescription: 'Light Logo',
    logos: 'Logos',
    manageExistingThemes: 'Manage existing themes',
    brandLogin: 'Login logo background',
    reset: 'Reset',
    save: 'Save',
    back: 'Back',
    title: 'Theme Configuration',
    yes: 'Yes',
    no: 'No',
    presets: 'Themes',
    themeColors: 'Theme Colors',
    unset: 'Unset',
    fileSizeTooLarge: 'File Size Too Large',
    themeName: 'Theme name',
    newTheme: 'New theme',
    systemThemeName: 'CargoWise default theme',
    editTheme: 'Edit theme',
    configureBy: 'Configure by',
    hostname: 'Hostname',
    organization: 'Organization',
    company: 'Company',
    branch: 'Branch',
    department: 'Department',
    configureTheme: 'Configure theme',
    createNewTheme: 'Create new theme',
    saveTheme: 'Save theme',
    system: 'System',
    userContact: 'User - Contact',
    userStaff: 'User - Staff',
    textColor: 'Text color',
    whiteText: 'White',
    blackText: 'Black',
    upload: 'Upload',
    navigation: 'Navigation',
    createdTime: 'Created time',
    createdUser: 'Created user',
    lastEditTime: 'Last edit time',
    lastEditUser: 'Last edit user'
  }
};

export { captions as default };
